// LaunchDarkly flag keys. Reference flags through these constants, not string literals.

// Enables Spanish translation and shows the language toggle
export const FLAG_SPANISH_ENABLED = 'originations-language-switcher-enable-202509';

// NeuroId should be on for all* stores. Disabled specifically for stores used by the E2E tests.
export const FLAG_NEUROID_ENABLED = 'originations-unified-ui-enable-neuroid-202608';

// When enabled, hides the Manual Entry link on the Plaid Offer page
export const FLAG_PLAID_REQUIRED = 'originations-plaid-required-202608';

// This is for the merchant BDS specifically. When enabled, contract signing on
// the customer's device is disabled outside the contract-summary re-entry
export const FLAG_DISABLE_CUSTOMER_DEVICE_CONTRACT_SIGNING = 'originations-disable-customer-device-contract-signing-202511';

// A/B test for showing more detailed C2 errors (new experience) vs a single generic error (old)
export const FLAG_NEW_C2_EXPERIENCE = 'originations-new-c2-experience-202510';

// Virtual card push-to-wallet provisioning
export const FLAG_PUSH_TO_WALLET_ENABLED = 'originations-push-to-wallet-enabled-202601';

// Show decision-code-specific debit soft-decline messages instead of the generic error
export const FLAG_SHOW_DEBIT_DECISION_SHORT_FORM = 'originations-show-debit-decision-short-form-202510';

// This needs to be retired, created a KTLO story to do so: OR-3120
export const FLAG_FULL_CARDHOLDER_NAME_ENABLED = 'originations-ui-full-cardholder-name-enable-202509';

// Show subtotal/estimated-tax breakdown on the virtual card Cart Total page
export const FLAG_VC_TAX_ESTIMATION = 'originations-unified-app-ui-vc-tax-estimation-202604';

// When enabled, the contract summary page will load with the 18 or 24-month product selected (18 over 24)
export const FLAG_USE_PREFERRED_LEASE_TERMS_ORDER = 'originations-use-preferred-lease-terms-order-202511';

// Owned by the risk/fraud team: stores allowed to bypass customer OTP
export const FLAG_OTP_BYPASS_WHITELIST = 'risk-fraud-otp-bypass-whitelist-perm';
